// @flow

import { createSelector } from "reselect"

import createAncillaryReducer from "../reducer"
import {
  serviceApplicableSelector,
  servicePriceSelector,
  serviceAddedSelector,
  serviceApplicableSegmentsSelector,
} from "../selectors"
import Price from "common/records/Price"

const blueribbonBagsReducer = createAncillaryReducer("blueribbonBags")

export default blueribbonBagsReducer

export const isBlueribbonBagsEnabled: $FlowFixMe = createSelector(
  state => state.splitster,
  splitster => splitster.get("BLUE_RIBBON_BAGS").value === "show",
)

export const isBlueribbonBagsApplicableSelector: $FlowFixMe = createSelector(
  serviceApplicableSelector("blueribbonBags"),
  isBlueribbonBagsEnabled,
  (applicable, enabled) => applicable && enabled,
)

export const getBlueribbonBagsPrice = servicePriceSelector("blueribbonBags")

export const blueribbonBagsAddedSelector: $FlowFixMe = createSelector(
  serviceAddedSelector("blueribbonBags"),
  isBlueribbonBagsApplicableSelector,
  (added, applicable) => added && applicable,
)

export const blueribbonBagsOrderedPriceSelector: $FlowFixMe = createSelector(
  getBlueribbonBagsPrice,
  blueribbonBagsAddedSelector,
  (blueribbonBagsPrice, blueribbonBagsAdded) =>
    blueribbonBagsAdded ? blueribbonBagsPrice : new Price({ amount: 0 }),
)

export const blueribbonBagsFormattedSelector: $FlowFixMe = createSelector(
  serviceApplicableSegmentsSelector("blueribbonBags"),
  blueribbonBagsAddedSelector,
  (segments, added) => {
    if (!added) return null

    return segments.map((segment, id) => ({
      price: segment.price,
      passenger_idx: id,
    }))
  },
)
